module.exports = __webpack_public_path__ + "img/zhongan-big.a28b88d7.jpg";